export type KeyCategoria =
  | 'extraversion'
  | 'agreeableness'
  | 'conscientiousness'
  | 'neuroticism'
  | 'openness'

export type Pregunta = {
  id: string
  texto: string
  reverse?: boolean
}

export const CATEGORIAS: Record<KeyCategoria, string[]> = {
  extraversion: ['1', '6', '11', '16', '21', '26', '31', '36'],
  agreeableness: ['2', '7', '12', '17', '22', '27', '32', '37', '42'],
  conscientiousness: ['3', '8', '13', '18', '23', '28', '33', '38', '43'],
  neuroticism: ['4', '9', '14', '19', '24', '29', '34', '39'],
  openness: ['5', '10', '15', '20', '25', '30', '35', '40', '41', '44'],
}
export const PREGUNTAS: Pregunta[] = [
  {
    id: '1',
    texto: 'A quien le gusta hablar',
  },
  {
    id: '2',
    texto: 'Que tiende siempre a encontrar fallas en los demás',
    reverse: true,
  },
  {
    id: '3',
    texto: 'Que tiene capacidad para finalizar una tarea',
  },
  { id: '4', texto: 'Que es depresivo/a o triste' },
  { id: '5', texto: 'Que es original y a quien se le ocurren nuevas ideas' },
  {
    id: '6',
    texto: 'Que es reservado/a',
    reverse: true,
  },
  {
    id: '7',
    texto: 'Que ayuda a los demás y no es egoísta',
  },
  {
    id: '8',
    texto: 'Que puede ser un poco descuidado/a',
    reverse: true,
  },
  {
    id: '9',
    texto: 'Que es relajado/a y que maneja bien los problemas',
    reverse: true,
  },
  {
    id: '10',
    texto: 'Que es curioso/a respecto de las cosas',
  },
  { id: '11', texto: 'Que está lleno/a de energía' },
  { id: '12', texto: 'Que empieza peleas con los demás', reverse: true },
  { id: '13', texto: 'Que es un trabajador/a confiable' },
  { id: '14', texto: 'Que puede ser tenso/a' },
  { id: '15', texto: 'Que es ingenioso/a' },
  { id: '16', texto: 'Que siempre genera mucho entusiasmo' },
  { id: '17', texto: 'Que puede perdonar de manera natural' },
  { id: '18', texto: 'Que tiende a ser desorganizado/a', reverse: true },
  { id: '19', texto: 'Que se preocupa mucho por todo' },
  { id: '20', texto: 'Que tiene una imaginación muy activa' },
  { id: '21', texto: 'Que tiende a ser callado/a', reverse: true },
  { id: '22', texto: 'Que generalmente es muy confiable' },
  { id: '23', texto: 'Que tiende a ser perezoso/a', reverse: true },
  {
    id: '24',
    texto: 'Que es emocionalmente estable y que no se altera fácilmente',
    reverse: true,
  },
  { id: '25', texto: 'Que es imaginativo/a' },
  { id: '26', texto: 'Que tiene una personalidad asertiva' },
  { id: '27', texto: 'Que puede ser frío/a y distante', reverse: true },
  { id: '28', texto: 'Que persevera hasta que las tareas estén terminadas' },
  { id: '29', texto: 'Que puede tener alteraciones en los estados de ánimo' },
  { id: '30', texto: 'Que tiene valores artísticos' },
  { id: '31', texto: 'Que a veces es tímido/a e inhibido/a', reverse: true },
  { id: '32', texto: 'Que es muy considerado/a y amable con los demás' },
  { id: '33', texto: 'Que hace las cosas de modo eficiente' },
  {
    id: '34',
    texto: 'Que permanece calmo/a en situaciones tensas',
    reverse: true,
  },
  { id: '35', texto: 'Que prefiere el trabajo rutinario', reverse: true },
  { id: '36', texto: 'Que es sociable' },
  {
    id: '37',
    texto: 'Que a veces puede tratar mal a los demás',
    reverse: true,
  },
  { id: '38', texto: 'Que puede fijarse metas y seguirlas' },
  { id: '39', texto: 'Que se pone nervioso/a fácilmente' },
  { id: '40', texto: 'A quien le gusta pensar y reflexionar' },
  { id: '41', texto: 'Que tiene pocos intereses artísticos', reverse: true },
  { id: '42', texto: 'A quien le gusta cooperar con los demás' },
  { id: '43', texto: 'Que se distrae fácilmente', reverse: true },
  {
    id: '44',
    texto: 'Que tiene gustos sofisticados en arte, música o literatura',
  },
]

const normalizar = (categoria: KeyCategoria, valor: number) => {
  const percentiles = [5, 10, 20, 25, 30, 40, 50, 60, 70, 75, 80, 90, 95]
  const tabla = {
    extraversion: [16, 20, 22, 23, 24, 26, 27, 29, 30, 31, 32, 34, 36],
    agreeableness: [25, 27, 30, 31, 32, 33, 34, 36, 38, 38, 39, 41, 43],
    conscientiousness: [22, 24, 26, 28, 29, 31, 35, 37, 37, 38, 42, 43],
    neuroticism: [12, 14, 16, 17, 19, 20, 22, 23, 25, 26, 29, 30, 32],
    openness: [24, 27, 31, 32, 34, 36, 37, 39, 41, 42, 43, 45, 47],
  }

  const percentilIndex = tabla[categoria].reduce(
    (acum, curr, index) => {
      const [, prevDistance] = acum
      return curr - valor <= prevDistance ? [index, valor - curr] : acum
    },
    [0, 0]
  )

  return percentiles[percentilIndex[0]]
}

export const calculoFeedbackOcean = (valores: Record<number, string>) =>
  Object.entries(CATEGORIAS).flatMap(([categoria, ids]) => {
    const preguntasCategoria = PREGUNTAS.filter(_ => ids.includes(_.id))
    const totalCategoria = preguntasCategoria
      .map(pregunta => ({
        value: parseInt(valores[parseInt(pregunta.id)]!),
        reverse: pregunta.reverse,
      }))
      .reduce((total, actual) => {
        return total + (actual.reverse ? 6 - actual.value : actual.value)
      }, 0)

    const percentilCalculado = normalizar(
      categoria as KeyCategoria,
      totalCategoria
    )
    return [
      [categoria, totalCategoria],
      [`percentil_${categoria}`, percentilCalculado],
      [
        `${categoria}_percentil_mostrado`,
        categoria === 'neuroticism'
          ? 100 - percentilCalculado
          : percentilCalculado,
      ],
    ]
  })
